import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { size, sumBy } from 'lodash';
import { showForm } from '../../store/formSlice';
import { DownloadsPanel } from './DownloadsPanel';
import { selectToDownload, setAsDownloaded, setSelectionMode } from '../../store/dataSlice';
import { Modal } from '../../components/Modal';
import { Paragraph } from '../../components/Text';
import { fixPackageSize } from '../../utils';
import { downloadPackage } from '../../store/uploadSlice';

const DownloadsContainer = () => {
    const dispatch = useDispatch();
    const { visible } = useSelector(state => state.form);
    const { selectedItems } = useSelector(state => state.data);
    const { isAdmin } = useSelector(state => state.user.grants);

    useEffect(() => {
        if (!size(selectedItems)) dispatch(showForm(false));
    }, [size(selectedItems)])

    const confirmDownloadPackages = (e) => {
        e.preventDefault();
        Modal.confirm({
            content: <Paragraph>Are you sure you want to download <b>{size(selectedItems)} package{size(selectedItems) != 1 && "s"}</b> with a total size about <b>{fixPackageSize(sumBy(Object.values(selectedItems), d => d.size))}</b>?</Paragraph>,
            okText: "Yes",
            okButtonProps: {style: { height: "40px", padding: "0px 21px", background: "var(--sp-main-color)", borderRadius: "8px", border: "none" }},
            onOk: () => {
                Object.values(selectedItems).map(d => d.files.map(file =>
                    dispatch(downloadPackage({ key: file, minos: d.minos }))
                    .unwrap()
                    .then(res => isAdmin || res != file ? null : dispatch(setAsDownloaded(res)))
                ));
                dispatch(setSelectionMode());
            }
        })
    };


    return(
        visible === "downloads" && size(selectedItems)
            ? <DownloadsPanel
                onClose={() => dispatch(showForm(false))}
                downloads={selectedItems}
                deselectPackage={(id) => dispatch(selectToDownload({key: id}))}
                downloadPackages={confirmDownloadPackages}
                clearPackages={() => dispatch(setSelectionMode())}
            />
            : null
    )
};

export { DownloadsContainer };